const routes = {
  HOME: '/',
  ACTIVATION: '/activation/',
  REGISTER: '/register/',
  LOGIN: '/login/',
  RESET_FIRST_ACCESS: '/reset-password-first-access/',
  TWO_FACTOR: '/two-factor/',
  DASHBOARD: '/dashboard/',
  FORUM: '/forum/',
  DISCUSSION: '/discussion/',
  EDIT_DISCUSSION: '/forum/edit-discussion/',
  NEW_DISCUSSION: '/forum/new-discussion/',
  MEMBERS: '/members/',
  JOBS: '/jobs/',
  JOB: '/job/',
  NEWS: '/news/',
  FACILITY: '/facility/',
  FACILITIES: '/facilities/',
  SITE: '/site/',
  INVOICES: '/invoices/',
  NOTIFICATIONS: '/notifications/',
  CALENDAR: '/calendar/',
  MEETING_DOCUMENTS: '/meeting-documents/',
  PUBLICATIONS: '/publications/',
  SUBSCRIPTIONS: '/subscriptions/',
  CONTACT: '/contact/',
  TA_USEFUL_RESOURCES: '/useful-resources-ta/',
  PROFILE: '/profile/',
  PROFILE_2FA: '/profile2fa/',
  CHANGE_PASSWORD: '/change-password/',
  EDIT_PROFILE: '/edit-profile/',
  ABOUT: '/about/',
  TERMS_AND_CONDITIONS: '/terms-conditions/',
  ADMIN: {
    OUTSTANDING_ACTIVITIES: "/admin/outstanding-activities/",
    EDIT_REGISTRATION: '/admin/edit-registration/',
    EDIT_PERSONAL_DETAILS: '/admin/edit-personal-details/',
    PENDING_REGISTRATION: '/admin/pending-registration/',
    PENDING_REGISTRATION_ALL: '/admin/pending-registration-all/',
    PENDING_PROFILE_CHANGE: '/admin/pending-profile-change/',
    PENDING_PROFILE_CHANGE_ALL: '/admin/pending-profile-change-all/',
    USER: '/admin/user/',
    USERS: '/admin/users/',
    REPORTS: '/admin/reports/',
    NOTIFICATIONS: '/admin/notifications/',
    MANAGE_COMMITTEES: '/admin/manage-committees/'
  }
};

export default routes;
